import axios from "axios";
import Modal from "react-modal";
import "./UserAccountDetails.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as Type } from "../../../../../images/icons/type.svg";
import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as Delete } from "../../../../../images/icons/delete.svg";
import { ReactComponent as EmailIcon } from "../../../../../images/icons/email.svg";
import { ReactComponent as Payment } from "../../../../../images/icons/payment.svg";
import { ReactComponent as LocationIcon } from "../../../../../images/icons/location.svg";
import AccountDetailsEdit from "./UserAccountEdit/UserAccountEdit";
import { ReactComponent as PassportlIcon } from "../../../../../images/icons/passport.svg";
import { ReactComponent as BirthIcon } from "../../../../../images/icons/dat-of-birth.svg";
import { ReactComponent as PostalCode } from "../../../../../images/icons/postal-code.svg";
import { logout, reset } from "../../../../../features/auth/authSlice";
import { ReactComponent as UserIcon } from "../../../../../images/icons/single-user-icon.svg";
import { ReactComponent as TypeContact } from "../../../../../images/icons/type-of-contact.svg";
import { reset as invoiceReset } from "../../../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../../features/appSettings/appSettingsSlice.js";
import { setBankFetchUpdate } from '../../../../../features/bankFetchUpdate/bankFetchUpdateSlice';

const AccountDetails = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [accountEdit, setAccountEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [bankDetailsView, setbankDetailsView] = useState([]);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const fileInputRef = useRef(null);
  const deleteLinkRef = useRef(null);
  const token = useSelector(
    (state) => state.auth.token
  )

  useEffect(() => {
    global.config.activityLog(
      window.location.href,
      "User",
      `Entered into User (${props.id}) view page`
    );
    async function fetchBank() {
      setIsLoading(true);
      try {
        const response = await axios.get(`/api/wise/user/banks/details/${props.accountId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setbankDetailsView(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        global.config.slackMessage(error.toString());
        if (error.response?.data?.status === "deleted") {
          localStorage.removeItem("user");
          dispatch(logout());
          dispatch(reset());
          dispatch(invoiceReset());
          dispatch(headerReset());
          dispatch(appSettingsReset());
          toast.error('This user is deleted!', {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
          return;
        }
        alert(`Error fetching bank`);
      }
    }

    fetchBank().then(() => {
      //   alert("Data fetched successfully!");
    });
  }, [props.accountId, accountEdit, navigate, token]);

  // Blur delete link when modal opens to prevent aria-hidden warning
  useEffect(() => {
    if (showConfirmation && deleteLinkRef.current) {
      deleteLinkRef.current.blur();
    }
  }, [showConfirmation]);

  const handleCloseModal = () => {
    setShowConfirmation(false);
    // Remove React Modal body class when modal closes
    document.body.classList.remove("ReactModal__Body--open");
  };

  const handleDeleteClick = (e) => {
    e.preventDefault();
    // Blur the link immediately and remove focus before opening modal
    const target = e.currentTarget;
    if (target) {
      target.blur();
      // Remove focus programmatically
      if (document.activeElement === target) {
        document.activeElement.blur();
      }
    }
    // Use requestAnimationFrame to ensure blur completes before modal opens
    requestAnimationFrame(() => {
      setShowConfirmation(true);
    });
  };

  const handleConfirmationOk = async (profileId, email, accountNumber) => {
    setIsDeleteLoading(true);
    try {
      await axios.post(`/api/wise/profile/delete`,
        {
          profileId: profileId,
          email: email,
          accountNumber: accountNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((response) => {
          toast.success("Bank account deleted successsfully!", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          global.config.activityLog(
            window.location.href,
            "User Bank",
            `Bank account for ${email} has been deleted successfully.`
          );
          dispatch(setBankFetchUpdate());
          handleCancel();
        }).catch((error) => {
          console.log(error)
        });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      global.config.activityLog(
        window.location.href,
        "User Bank",
        `Something went wrong while deleting Bank account for ${email}.`
      );
      alert(`Error deletion of bank account`);
    }
    setIsDeleteLoading(false);
    handleCloseModal();

  };
  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
  };
  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
      {accountEdit ? (
        <>
          <AccountDetailsEdit />
        </>
      ) : (
        <>
          <div className="account-details-backdrop" onClick={handleCancel} />
          <div className="account-details">
            <div className="profile-photo-outer">
              <div className="profile-photo">
                {isLoading ? (
                  <div
                    style={{
                      width: "120px",
                      height: "30px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                ) : (
                  <div className="account-details-title-wrapper">
                    <button
                      type="button"
                      className="account-details-mobile-close-btn"
                      onClick={handleCancel}
                      aria-label="Close"
                    >
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                    <h2>Account #{props.index}</h2>
                  </div>
                )}
              </div>
              <div className="profile-button">
                {isLoading ? (
                  <div
                    style={{
                      width: "100px",
                      height: "36px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                ) : (
                  <a
                    ref={deleteLinkRef}
                    className="delete-profile"
                    onClick={handleDeleteClick}
                    tabIndex={showConfirmation ? -1 : undefined}
                  >
                    <span className="bt-ico">
                      <Delete aria-hidden="true" />
                    </span>
                    Delete
                  </a>
                )}
              </div>
            </div>
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileInputChange}
            />
            {showConfirmation && (
              <Modal
                className="delete-modal account-delete-confirm-modal"
                overlayClassName={{
                  base: "ReactModal__Overlay account-delete-confirm-overlay",
                  afterOpen: "ReactModal__Overlay--after-open",
                  beforeClose: "ReactModal__Overlay--before-close",
                }}
                isOpen={showConfirmation}
                onRequestClose={handleCloseModal}
                contentLabel="Confirmation Delete"
                style={{
                  overlay: {
                    zIndex: 1000001,
                  },
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "36%",
                    left: "50%",
                    zIndex: 1000002,
                  },
                }}
              >
                <div className="delete-modal-content">
                  <h2>Confirm Delete</h2>
                  <p>
                    Are you sure you want to delete this Account?
                  </p>
                  <div className="delete-modal-buttons">
                    <button className="buttons-rejected" onClick={() => handleConfirmationOk(bankDetailsView.id, bankDetailsView.details.email, (bankDetailsView.details.accountNumber || bankDetailsView.details.iban || bankDetailsView.details.clabe))} disabled={isDeleteLoading}>
                      {isDeleteLoading ? (
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "2px solid #ffffff",
                            borderTop: "2px solid transparent",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            margin: "0 auto",
                          }}
                        />
                      ) : "Delete"}
                    </button>
                    <button onClick={handleCloseModal}>
                      Cancel
                    </button>
                  </div>
                </div>
              </Modal>
            )}

            {showSuccessMessage && (
              <div className="success-message">
                Profile deleted successfully!
              </div>
            )}
            {isLoading ? (
              <div className="information-outer-section">
                <div className="information-inner">
                  <div className="information">
                    <div className="information-title">Personal Information</div>
                    <div className="information-outer">
                      <div className="information-left">
                        {Array.from({ length: 8 }).map((_, index) => (
                          <div key={`skeleton-left-${index}`} className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "120px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "150px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="information-right">
                        {Array.from({ length: 8 }).map((_, index) => (
                          <div key={`skeleton-right-${index}`} className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "120px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "150px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="information-inner">
                  <div className="information">
                    <div className="information-title">Address</div>
                    <div className="information-outer">
                      <div className="information-left">
                        {Array.from({ length: 2 }).map((_, index) => (
                          <div key={`skeleton-address-left-${index}`} className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "80px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "150px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="information-right">
                        {Array.from({ length: 2 }).map((_, index) => (
                          <div key={`skeleton-address-right-${index}`} className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "100px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                <div
                                  style={{
                                    width: "150px",
                                    height: "20px",
                                    backgroundColor: "#e5e7eb",
                                    borderRadius: "4px",
                                    animation: "pulse 1.5s ease-in-out infinite",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginLeft: "35px", marginTop: "20px" }}>
                  <div
                    style={{
                      width: "100px",
                      height: "36px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="information-outer-section">
                <div className="information-inner">
                  <div className="information">
                    <div className="information-title">Personal Information</div>
                    <div className="information-outer">
                      <div className="information-left">
                        {bankDetailsView.accountHolderName && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <UserIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Account Holder Name</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.accountHolderName}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.business && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <UserIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Wise Profile</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.business}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.type && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Type</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.type}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.accountType && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Account Type</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.accountType}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.transitNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <PassportlIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Transit Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.transitNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.sortCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Sort Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.sortCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.abartn && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>ABARTN</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.abartn}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.bankgiroNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Bankgiro Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.bankgiroNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.ifscCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Ifsc Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.ifscCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.bsbCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>BSB Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.bsbCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.phoneNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Phone Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.phoneNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.bankCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Bank Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.bankCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.russiaRegion && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Russia Region</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.russiaRegion}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.routingNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Routing Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.routingNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.branchCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Branch Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.branchCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.cpf && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>CPF</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.cpf}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.cardToken && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Card Token</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.cardToken}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.idType && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Id Type</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.idType}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.idNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Id Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.idNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.idCountryIso3 && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Id Country Iso3</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.idCountryIso3}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.idValidFrom && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Id Valid From</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.idValidFrom}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.idValidTo && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Id Valid To</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.idValidTo}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.cardToken && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Card Token</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.cardToken}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.clabe && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Clabe</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.clabe}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.swiftCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Swift Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.swiftCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.prefix && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Prefix</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.prefix}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.IBAN && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>IBAN</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.IBAN}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.BIC && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>BIC</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.BIC}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="information-right">
                        {bankDetailsView.id && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <PassportlIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Wise ID</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.id}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.currency && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Payment aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Currency</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.currency}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.legalType && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Legal Type</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.legalType}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.accountNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Account Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.accountNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.institutionNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Institution Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.institutionNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.dateOfBirth && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <BirthIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Date Of Birth</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.dateOfBirth}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.clearingNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Clearing Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.clearingNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.bankName && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Bank Name</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.bankName}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.branchName && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Branch Name</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.branchName}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.businessNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Business Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.businessNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.province && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Province</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.province}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.rut && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>RUT</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.rut}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.token && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Token</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.token}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.cnpj && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>CNPJ</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.cnpj}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.payinReference && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Payin Reference</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.payinReference}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.pspReference && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Psp Reference</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.pspReference}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.orderId && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Order Id</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.orderId}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.idDocumentType && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Id Document Type</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.idDocumentType}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.targetProfile && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Target Profile</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.targetProfile}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.targetUserId && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Target User Id</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.targetUserId}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.taxId && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Tax Id</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.taxId}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.job && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Job</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.job}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.nationality && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Nationality</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.nationality}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.interacAccount && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Interac Account</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.interacAccount}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.bban && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>B Ban</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.bban}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.town && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Town</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.town}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.language && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Language</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.language}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.billerCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <Type aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Biller Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.billerCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.customerReferenceNumber && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <TypeContact aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Customer Reference Number</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.customerReferenceNumber}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="information-inner">
                  <div className="information">
                    <div className="information-title">Address</div>
                    <div className="information-outer">
                      <div className="information-left">
                        {bankDetailsView.details.address.city && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <LocationIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>City</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.address.city}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.address.country && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <LocationIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Country</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.address.country}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.address.state && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <LocationIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>State</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.address.state}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="information-right">
                        {bankDetailsView.details.address.firstLine && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <LocationIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Address</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.address.firstLine}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.address.postCode && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <PostalCode aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Postal Code</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.address.postCode}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {bankDetailsView.details.email && (
                          <div className="inner-detail-outer">
                            <div className="inner-detail">
                              <span className="icon">
                                <EmailIcon aria-hidden="true" />
                              </span>
                              <div className="inner-detail-inner">
                                <label>Email</label>
                              </div>
                            </div>
                            <div className="inner-detail">
                              <span className="icon"></span>
                              <div className="inner-detail-inner">
                                {isLoading ? (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "20px",
                                      backgroundColor: "#e5e7eb",
                                      borderRadius: "4px",
                                      animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                  />
                                ) : (
                                  <div className="value-field">{bankDetailsView.details.email}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <a className="cancel-btn" onClick={handleCancel} >Cancel</a>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AccountDetails;